import { render, staticRenderFns } from "./posPayment.vue?vue&type=template&id=6d513fb6&scoped=true&"
import script from "./posPayment.vue?vue&type=script&lang=js&"
export * from "./posPayment.vue?vue&type=script&lang=js&"
import style0 from "./posPayment.vue?vue&type=style&index=0&id=6d513fb6&prod&scoped=true&lang=css&"
import style1 from "./posPayment.vue?vue&type=style&index=1&id=6d513fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d513fb6",
  null
  
)

export default component.exports